module.exports = __webpack_public_path__ + "img/icon-close.974c9ba9.svg";